// const devHost = `http://${window.location.host}/paraconc`
// const __DEV__ = true
const __DEV__ = process.env.NODE_ENV === 'development'
// const devHost = __DEV__ ? `http://localhost/paraconc` : `http://${window.location.host}/paraconc`
const devHost = __DEV__ ? `https://corpus.eduhk.hk/paraconc` : `http://${window.location.host}/paraconc`
const productionPrefix = '../paraconc/api/'
const api = __DEV__ ? {
    SEARCH_PARALLEL_API: devHost + '/api/searchParallel.php',
    SEARCH_MONO_API: devHost + '/api/searchMonolingual.php',
    GET_NEARBY_PARALLEL_TEXT_API: devHost + '/api/getParallelTextByAlignmentId.php',
    GET_NEARBY_MONO_TEXT_API: devHost + '/api/getMonoTextBySentenceId.php',
    GET_BOOK_LIST_API: devHost + '/api/getBookList.php'
} : {
    SEARCH_PARALLEL_API: productionPrefix + 'searchParallel.php',
    SEARCH_MONO_API: productionPrefix + 'searchMonolingual.php',
    GET_NEARBY_PARALLEL_TEXT_API: productionPrefix + 'getParallelTextByAlignmentId.php',
    GET_NEARBY_MONO_TEXT_API: productionPrefix + 'getMonoTextBySentenceId.php',
    GET_BOOK_LIST_API: productionPrefix + 'getBookList.php'
}

export default api;
